module.exports = __webpack_public_path__ + "media/bootstrap-icons/kanban-fill-f5dc444f.svg";